import _ from 'lodash';

const yup = require('yup');

const emptyValueTransformer = (cv, ov) => (ov === '' ? undefined : cv);

function mapValidations(attr) {
  const { validations, friendly } = attr;
  let rule = yup;

  switch (validations.type) {
    case 'decimal':
      rule = rule.number().typeError(`${friendly} must be a number`);
      break;
    case 'integer':
    case 'foreignKey':
      rule = rule
        .number()
        .typeError(`${friendly} must be a number`)
        .integer(`${friendly} must be a whole number`);
      break;
    case 'date':
      rule = rule.date(`${friendly} must be a date`);
      break;
    case 'enum':
      rule = rule
        .string()
        .trim()
        .oneOf(_.keys(validations.enumType));
      break;
    default:
      rule = rule.string().trim();
  }

  rule = rule.transform(emptyValueTransformer);

  if (validations.default) {
    rule = rule.default(validations.default);
  }

  if (validations.isRequired) {
    rule = rule.required(`${friendly} is required`);
  } else {
    rule = rule.notRequired();
  }

  if (validations.maxLength) {
    rule = rule.max(
      validations.maxLength,
      `${friendly} has a maximum length of {validations.maxLength} characters`
    );
  }

  if (validations.minLength) {
    rule = rule.min(
      validations.minLength,
      `${friendly} has a minimum length of {validations.minLength} characters`
    );
  }

  if (validations.mustBePositive) {
    rule = rule.positive(`${friendly} must be a positive number`);
  }

  return rule;
}

/**
 * Transforms a set of data attributes into a Yup validation schema.
 * Accepts an array of data attribute collections so that you can combine
 * generic attributes (item title, description, etc.) with category-specific
 * attributes (watch attributes, car attributes, etc.).
 * @param {object} dataAttributes An array of objects describing sets of data attributes
 */
export default function generateValidationSchema(dataAttributes) {
  const schema = yup.object();

  const validations = dataAttributes.reduce((outerAccum, [prefix, attributes]) => {
    outerAccum[prefix] = yup
      .object()
      .shape(_.reduce(
        attributes,
        (accum, entry, entryKey) => {
          accum[entryKey] = mapValidations(entry);
          return accum;
        },
        {}
      ))
      .required();

    return outerAccum;
  }, {});

  return schema.shape(validations);
}



// WEBPACK FOOTER //
// ./src/validationGenerator.js